import {LinkProps} from 'react-router-dom'
import {StyledButtonLink} from './style'

interface ButtonLinkProps extends LinkProps {
    disabled?: boolean
    fullWidth?: boolean
    iconOnly?: boolean
    size?: 'sm' | 'md' | 'lg'
    variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost'
}

export const ButtonLink = ({
    children,
    fullWidth = false,
    disabled = false,
    iconOnly = false,
    size = 'md',
    variant = 'primary',
    ...rest
}: ButtonLinkProps) => (
    <StyledButtonLink
        $disabled={disabled}
        $fullWidth={fullWidth}
        $iconOnly={iconOnly}
        $size={size}
        $variant={variant}
        {...rest}
    >
        {children}
    </StyledButtonLink>
)

ButtonLink.displayName = 'ButtonLink'
